<template>
  <div>
    <div v-if="mid == 1949 && cpyId == 110" :style="{ 'min-height': pageHeight }">
      <div class="flex-row-start sidebox" v-for="(item, index) in managementList[0].subMenuList" :key="index">
        <div class="leftside flex-col" style="position:absolute;height:100%;width:200px;top:0;left:0;">
          <img class="leftsideImg" :src="item.icon">
          <div style="font-size:19px">{{ item.showName }}</div>
        </div>
        <div class="leftside flex-col"></div>
        <div class="rightside flex-row-start2">
          <div class="boxitem flex-row-start" v-for="(item2, index2) in item.subMenuList" :key="index2"
            @click="gourl(item2)">
            <img class="boxitemImg" :src="item2.icon">
            <div style="font-size:19px;color:#646464;">{{ item2.showName }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-card style="margin: 40px 10px;position: relative;" v-else>
      <img src="../assets/memuBj.jpg" class="image">
      <div class="image_title">
        <template v-if="sType == '' || sType == 1 || sType == 2">
          <div class="image_title_title"></div>
          <div class="image_title_box">
            <span>智教荟系列产品之—</span>
            <span>{{ titleList.title }}</span>
          </div>
        </template>
        <div class="image_title_box2 " v-else>
          <span>{{ titleList.title }}</span>
        </div>
      </div>
      <div class="image_box">
        <span>{{ titleList.content }}</span>
      </div>

    </el-card>
    <el-dialog title="实习生请销假待审批提示" :visible.sync="approvedialogVisible" :width="'min(520px, 92%)'">
      <div style="font-size:14px">实习生请销假待审批列表：</div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="实习任务名称" width="180">
        </el-table-column>
        <el-table-column prop="count" label="请销假待审批个数" width="180">
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="goapprove(scope.row)">去审批</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['activeIndex'],
  data() {
    return {
      activeIndex: 0,
      title: '',
      managementList: [],
      titleList: {},
      sType: '',
      cpyId: '',//单位，天门110
      pageHeight: '',
      mid: '',
      approvedialogVisible: false,
      tableData: [],
      manageOrDepart: ''
    }
  },
  watch: {
    activeIndex: function (val) {
      this.activeIndex = val
      console.log(val)
      let activeIndex = Number(val)
      this.titleList = this.managementList[activeIndex].sysMenuIntroduce
      this.mid = this.managementList[activeIndex].mid
      console.log(this.titleList)
    }
  },
  mounted() {
    let user = JSON.parse(window.sessionStorage.getItem('userAccount'))
    this.cpyId = user.cpyId
    this.pageHeight = document.documentElement.clientHeight + "px";
    if (window.localStorage.getItem('sType')) {
      this.sType = window.localStorage.getItem('sType')
    }
    if (this.cpyId == 110) {
      //科室管理员、管理部门管理员 查请销假待办
      let roleList = user.roleList
      let flag = false
      roleList.forEach((i) => {
        if (i == 17 || i == 18) {
          flag = true
        }
      })
      if (flag == true) {
        this.getApprove()
      }
    }
  },
  created() {
    this.getMenuList()
  },
  methods: {
    goapprove(item) {
      this.approvedialogVisible = false
      if (this.manageOrDepart == 'manage') {
        this.$router.push({
          path: '/stuApproveManage',
          query: {
            inId: item.id,
            name: item.name
          }
        })
      }
      if (this.manageOrDepart == 'depart') {
        this.$router.push({
          path: '/stuApprove',
          query: {
            inId: item.id,
            name: item.name
          }
        })
      }
    },
    async getApprove() {
      const {
        data: res
      } = await this.$Http.planleaveunDealcount()
      console.log(res)
      if (res.result !== 0) {
        return this.$message.error(res.data.msg)
      }
      if (res.data.total != null && res.data.total > 0) {
        this.approvedialogVisible = true
        this.tableData = res.data.list
        this.manageOrDepart = res.data.manageOrDepart
      }
    },
    gourl(item) {
      console.log(item)
      this.$router.push('/' + item.url)
    },
    // 获取所有的菜单
    async getMenuList() {
      const {
        data: res
      } = await this.$Http.userMemu()
      console.log(res)
      if (res.result !== 0) return this.$message.error(res.msg)
      this.managementList = JSON.parse(JSON.stringify(res.data.slice(0)));
      console.log(this.managementList, '--菜单')
      // this.managementList.shift();
      let activeIndex = Number(this.activeIndex)
      this.titleList = this.managementList[activeIndex].sysMenuIntroduce
      this.mid = this.managementList[activeIndex].mid
      console.log(this.titleList)
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-card__body {
  padding: 0;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
  position: relative;
}

.image_title {
  position: absolute;
  display: flex;
  left: 120px;
  top: 100px;

  .image_title_title {
    width: 3px;
    height: 80px;
    background-color: #FFFFFF;
  }

  .image_title_box {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;

    span:nth-child(1) {
      display: inline-block;
      font-size: 18px;
      color: #FFFFFF;
      letter-spacing: 2pt;
    }

    span:nth-child(2) {
      font-size: 28px;
      color: #FFFFFF;
      letter-spacing: 2pt;
    }
  }

  .image_title_box2 {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;

    span {
      font-size: 28px;
      color: #FFFFFF;
      letter-spacing: 2pt;
      line-height: 80px;
    }
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.image_box {
  padding: 20px;
  font-size: 14px;
  text-indent: 2em;
  line-height: 30px;
  word-wrap: break-word
}

.leftside {
  width: 200px;
  background: #e3f3fe;
  height: 100%;
  color: #0596f7;
  font-size: 18px;
}

.rightside {
  width: calc(100% - 220px);
}

.sidebox {
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 4px;
  overflow: hidden;
}

.boxitem {
  width: 224px;
  height: 100px;
  border-right: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
  box-sizing: content-box;
  cursor: pointer;
}

.boxitemImg {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  margin-left: 10%;
}

.leftsideImg {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
}
</style>
